import Badge from "@/Components/Badge/Badge";
import useLiveDay from "@/shared/atoms/useLiveDay";
import useCommon from "@/shared/hooks/useCommon";
import useUserSettingsQuery from "@/shared/queries/user/useUserSettingsQuery";
import { OrderStatus } from "@/shared/utils/enum";
import { useCallback } from "react";
import useLiveOrdersHook from "./useLiveOrdersHook";

const LiveDays = () => {
  const data = useLiveOrdersHook();
  const { data: settings } = useUserSettingsQuery();
  const t = useCommon();
  const [day, setDay] = useLiveDay();
  const hasNotConfirmedOrder = useCallback(
    (day: 0 | 1 | 2) => {
      return (
        !!data?.[day]?.length &&
        !data?.[day]?.every(
          (i) => i.order_information.order_status !== OrderStatus.ARRIVED
        )
      );
    },
    [data]
  );

  return (
    <div
      data-tour="live-orders.days"
      className="flex w-full flex-[0_1_auto] justify-between gap-2 overflow-auto md:w-auto"
    >
      <div
        onClick={() => setDay(0)}
        className={`cursor-pointer whitespace-nowrap px-8 py-6 text-center md:mr-4 md:px-12 ${day === 0 ? "bg-primary text-white" : "bg-white"}`}
      >
        {t("orders_live.today")}{" "}
        {settings.show_order_count && (
          <span className="font-black">({data?.[0]?.length ?? 0})</span>
        )}
        {hasNotConfirmedOrder(0) && <Badge />}
      </div>
      <div
        onClick={() => setDay(1)}
        className={`cursor-pointer whitespace-nowrap px-8 py-6 text-center md:mr-4 md:px-12 ${day === 1 ? "bg-primary text-white" : "bg-white"}`}
      >
        {t("orders_live.tomorrow")}{" "}
        {settings.show_order_count && (
          <span className="font-black">({data?.[1]?.length ?? 0})</span>
        )}
        {hasNotConfirmedOrder(1) && <Badge />}
      </div>
      <div
        onClick={() => setDay(2)}
        className={`cursor-pointer whitespace-nowrap px-8 py-6 text-center md:mr-4 md:px-12 ${day === 2 ? "bg-primary text-white" : "bg-white"}`}
      >
        {t("orders_live.later")}{" "}
        {settings.show_order_count && (
          <span className="font-black">({data?.[2]?.length ?? 0})</span>
        )}
        {hasNotConfirmedOrder(2) && <Badge />}
      </div>
    </div>
  );
};

export default LiveDays;
